// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-38L0p","loadingText":"index-loadingText--CR9w","loadingDot":"index-loadingDot-36qdU","dots":"index-dots-3zPMd"};